import React, { useEffect, useState } from "react";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";

export function LiveCell({ creator, field, type = "text", onUpdated }) {
  const isNumeric = type === "number";
  const [val, setVal] = useState(creator[field] ?? (isNumeric ? 0 : ""));
  const [saving, setSaving] = useState(false);
  useEffect(() => { setVal(creator[field] ?? (isNumeric ? 0 : "")); /* eslint-disable-next-line */ }, [creator.id]);

  const save = async () => {
    let next = val;
    if (isNumeric) next = parseInt(String(next).replace(/[^\d-]/g, "") || 0, 10) || 0;
    if (next === (creator[field] ?? (isNumeric ? 0 : ""))) return;
    setSaving(true);
    try {
      const { data } = await api.put(`/creators/${creator.id}`, { [field]: next });
      onUpdated?.(data);
    } catch (e) {
      toast.error(formatApiError(e.response?.data?.detail) || "Save failed");
      setVal(creator[field] ?? (isNumeric ? 0 : ""));
    } finally {
      setSaving(false);
    }
  };

  const inputType = isNumeric ? "text" : type;
  const extraProps = isNumeric ? { inputMode: "numeric", pattern: "[0-9]*" } : {};

  return (
    <Input
      type={inputType}
      value={val ?? ""}
      onChange={(e) => setVal(isNumeric ? e.target.value.replace(/[^\d-]/g, "") : e.target.value)}
      onBlur={save}
      onKeyDown={(e) => { if (e.key === "Enter") e.currentTarget.blur(); }}
      className={`h-8 text-xs ${isNumeric ? "font-mono text-right tabular-nums" : ""} ${saving ? "opacity-60" : ""}`}
      data-testid={`live-${field}-${creator.id}`}
      placeholder={isNumeric ? "0" : ""}
      {...extraProps}
    />
  );
}
